import React, { useState, useEffect } from 'react';
import { collection, onSnapshot, deleteDoc, doc, writeBatch } from 'firebase/firestore';
import { db } from '../../firebase'; 
import * as XLSX from 'xlsx';
import { toast } from 'react-toastify';
import './ReceiveInquiry.css';

const ReceiveInquiry = () => {
  const [inquiries, setInquiries] = useState([]);
  const [loading, setLoading] = useState(true);

  // Fetch inquiries in real-time
  useEffect(() => {
    // Ask for notification permission when the component is mounted
    if (Notification.permission !== 'granted') {
      Notification.requestPermission();
    }

    const unsubscribe = onSnapshot(
      collection(db, 'quotes'),
      (snapshot) => {
        const inquiryData = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setInquiries(inquiryData);
        setLoading(false);

        // Show a push notification when a new inquiry is received
        if (Notification.permission === 'granted') {
          new Notification('New Inquiry Received!', {
            body: 'You have a new inquiry. Check your dashboard.',
          });
        }
      },
      (error) => {
        console.error('Error fetching inquiries:', error);
        toast.error('Failed to fetch inquiries');
      }
    );
    return () => unsubscribe(); // Cleanup listener on component unmount
  }, []);

  // Function to delete a single inquiry
  const deleteInquiry = async (id) => {
    try {
      const docRef = doc(db, 'quotes', id);
      await deleteDoc(docRef);
      setInquiries(inquiries.filter((inquiry) => inquiry.id !== id));
      toast.success('Inquiry deleted successfully!');
    } catch (error) {
      console.error('Error deleting inquiry:', error);
      toast.error('Error deleting inquiry');
    }
  };

  // Function to delete all inquiries after confirmation
  const deleteAllInquiries = async () => {
    const confirmDelete = window.confirm('Are you sure you want to delete all inquiries?');
    if (confirmDelete) {
      try {
        const batch = writeBatch(db);
        inquiries.forEach((inquiry) => {
          const docRef = doc(db, 'quotes', inquiry.id);
          batch.delete(docRef);
        });
        await batch.commit();
        setInquiries([]);
        toast.success('All inquiries deleted successfully!');
      } catch (error) {
        console.error('Error deleting all inquiries:', error);
        toast.error('Error deleting all inquiries');
      }
    }
  };

  // Function to export inquiries as an Excel file
  const exportToExcel = () => {
    const ws = XLSX.utils.json_to_sheet(inquiries);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Inquiries');
    XLSX.writeFile(wb, 'Inquiries.xlsx');
  };

  return (
    <div className="receiveInquiry">
      <h1 className="dashboardTitle">Received Inquiries</h1>

      {/* Button to export data to Excel */}
      <button className="exportBtn" onClick={exportToExcel}>
        Download as Excel
      </button>

      {/* Button to delete all inquiries */}
      <button className="deleteAllBtn" onClick={deleteAllInquiries}>
        Delete All
      </button>

      {loading ? (
        <p>Loading...</p>
      ) : (
        <table className="inquiryTable">
          <thead>
            <tr>
              <th>Name</th>
              <th>Email</th>
              <th>Phone</th>
              <th>Program</th>
              <th>City</th>
              <th>Message</th>
              <th>Timestamp</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {inquiries.map((inquiry) => (
              <tr key={inquiry.id}>
                <td>{inquiry.name}</td>
                <td>{inquiry.email}</td>
                <td>{inquiry.phoneNumber}</td>
                <td>{inquiry.program}</td>
                <td>{inquiry.city}</td>
                <td>{inquiry.message}</td>
                <td>
                  {inquiry.timestamp && inquiry.timestamp.toDate
                    ? inquiry.timestamp.toDate().toLocaleString()
                    : 'N/A'}
                </td>
                <td>
                  <button
                    className="deleteBtn"
                    onClick={() => deleteInquiry(inquiry.id)}
                  >
                    Delete
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default ReceiveInquiry;
